<template>

    <modal-container>

        <div>

            <!-- Top navbar -->
            <modal-header
                :title="'Pre-order ' + params.name"
                :right="'close-dark'"
                :noIcon="true">
            </modal-header>

            <template>

                <!-- Prompt content -->
                <prompt-div class="text-dark">

                    <!-- Layout body -->
                    <template v-slot:body>

                        <div class="mt-6 d-flex align-items-center justify-content-center" style="height: 15rem; font-size: 0;">
                            <img src="images/illustration-confirmation.svg">
                        </div>

                        <div class="pt-6">
                            <h3 class="font-lg font-weight-bolder">{{ params.name }} is pre-ordered for you</h3>
                            <h4 class="font-md mt-5">Once operations are back to normal, we will send you a link to finish your purchase with us.</h4>
                        </div>
                        <button class="btn btn-md btn-inverted text-primary px-7 mt-6" @click="$root.closeModal()">
                            Ok, great!
                        </button>

                    </template>

                </prompt-div>

            </template>

        </div>

    </modal-container>

</template>

<script>
    export default {

        props: {
            params: {
                default: null,
            },
        }

    }
</script>